<!-- eslint-disable vue/no-v-html -->
<template>
  <!-- project result item container -->
  <div class="relative mb-8 text-gray-900 content__sections">
    <div class="flex flex-col sm:flex-row gap-y-4 gap-x-8">
      <a
        :href="result.html_url" class="mt-1.5 block w-full sm:w-48 flex-none"
      >
        <FocalImage
          v-if="result.hero && result.hero?.url"
          :image="{ url: result.hero?.url || '', alt: result.hero?.alt || '' }"
          img-class="w-full h-auto object-cover aspect-square"
        />
      </a>
      <div class="flex flex-col gap-y-2">
        <h4 class="m-0!">
          <a
            :href="result.html_url"
            v-html="highlightedTitle"
          />
        </h4>
        <h5 class="caption-1 m-0!">{{ publishedText }}</h5>
        <p class="line-clamp-5 text-ellipsis">
          {{ result.meta.search_description }}
        </p>
        <a :href="result.html_url" class="link-cta -left-1">LEARN MORE</a>
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>
import { computed } from 'vue'
import type { ISearchResult } from './ProjectList.vue'

/**
 * Component props
 */
const props = defineProps<{
  result: ISearchResult  // project search result data
  query: string         // Search query for highlighting
}>()

/**
 * Computed property that highlights search terms in the project title
 * Wraps matching query terms in <b> tags for visual emphasis
 */
const highlightedTitle = computed(() => {
  const title = props.result.title || ''
  if (!props.query) return title
  const regex = new RegExp(`(${decodeURI(props.query)})`, 'gi')
  return (
    title.replace(regex, '<b>$1</b>')
  )
})

/**
 * Formats the project date into a readable string
 * Returns empty string if no date or invalid date provided
 */
const publishedText = computed(() => {
  const val = props.result.project_date
  const updatedVal = props.result.project_date_updated
  let dateStr = ''
  // const last_published_at = props.result.last_published_at

  if (val) {
    const date = new Date(val)
    if (!isNaN(date.getTime())) {
      dateStr += 'Created ' + date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      })
    }
  }
  if (updatedVal) {
    const updatedDate = new Date(updatedVal)
    if (!isNaN(updatedDate.getTime())) {
      dateStr += `\u00a0\u00a0\u2022\u00a0\u00a0`  +
        'Updated ' + updatedDate.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      })
    }
  }
  return dateStr
})
</script>
